import { render, staticRenderFns } from "./ve-table-subchains.vue?vue&type=template&id=26b52c7b"
import script from "./ve-table-subchains.vue?vue&type=script&lang=js"
export * from "./ve-table-subchains.vue?vue&type=script&lang=js"
import style0 from "./ve-table-subchains.vue?vue&type=style&index=0&id=26b52c7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports